import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Link } from "@/mk2/components/Link";

import styles from "./BluePill.mscss";

interface BluePillProps {
    className?: string;
    to: string;
    label: React.ReactNode;
    icon?: IconDefinition;
}

export const BluePill: React.FunctionComponent<BluePillProps> = ({
    className,
    to,
    label,
    icon,
}) => (
    <Link className={cx(styles.BluePill, className)} to={to}>
        {icon && <FontAwesomeIcon icon={icon} className={styles.BluePill__icon} />}
        <span className={styles.BluePill__label}>{label}</span>
    </Link>
);

BluePill.displayName = "BluePill";
